var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-view-base-type-1',{attrs:{"value":_vm.value,"label":_vm.model.title}},[_c('a-view-table-phones',{attrs:{"value":_vm.value,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }